import { Loader2 } from "lucide-react";
import { useEffect, useRef } from "react";

// Scrolling log viewer. Used by the per-container Logs tab for both
// build and runtime feeds. Auto-scrolls to the bottom when new lines
// arrive so the most recent output is always visible.
export function LogPane({ lines, isLoading }: { lines: string[]; isLoading: boolean }) {
  const bottomRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [lines]);

  if (isLoading) {
    return (
      <div className="flex-1 flex items-center justify-center rounded-md bg-muted text-muted-foreground text-sm gap-2 min-h-0 h-full">
        <Loader2 className="size-4 animate-spin" />
        Loading logs…
      </div>
    );
  }
  return (
    <pre className="flex-1 overflow-auto rounded-md bg-muted p-4 text-xs font-mono whitespace-pre-wrap min-h-0 h-full">
      {lines.length ? lines.join("\n") : "No logs yet."}
      <div ref={bottomRef} />
    </pre>
  );
}
